<template>
    <div>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col cols="12">
                    <h4>Szczegóły</h4>
                    <v-data-table v-if="loadingDetails || details.length"
                                  :headers="headers"
                                  :items="details"
                                  hide-default-header
                                  hide-default-footer
                                  :server-items-length="20"
                                  :loading="loadingDetails"
                    >
                        <template v-slot:item.name="{ item }">
                            <strong>{{ item.name }}</strong>
                        </template>
                        <template v-slot:item.value="{ item }">
                          {{ item.value }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
          <v-row>
            <v-col cols="12">
              <h4>Oferty</h4>
              <v-data-table v-if="loadingDetails || details.length"
                            :headers="offerHeaders"
                            :items="this.wholesaleInquiry.offers"
                            hide-default-footer
                            :server-items-length="20"
                            :loading="loadingDetails"
              >
                <template v-slot:item.company="{ item }">
                  {{ item.company.name }}
                </template>
                <template v-slot:item.value="{ item }">
                  {{ item.value }} zł
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ localDateTime(item.createdAt) }}
                </template>
                <template v-slot:item.status="{ item }">
                  {{ getOfferStatusText(item.status) }}
                </template>
                <template v-slot:item.fulfillment="{ item }">
                  <template v-if="item.status === 'selected'">
                    {{ getFulfillmentText(item.fulfillment) }}
                    <div
                      v-if="item.fulfillment === 'unrealized' && item.fulfillmentReason"
                      class="grey--text text--darken-1"
                    >
                      Powód: {{ item.fulfillmentReason }}
                    </div>
                  </template>
                  <template v-else>—</template>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
    </div>
</template>

<script>
import api from '../services/api';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import {getStatusText} from "@/enums/WholesaleInquiryStatus";
import {getOfferStatusText} from "@/enums/WholesaleInquiryOfferStatus";

export default {
    components: {},
    mixins: [
        formatters,
        permissions,
    ],
    props: ['id'],
    data() {
        return {
            wholesaleInquiryId: null,
            headers: [
                {text: '', value: 'name'},
                {text: '', value: 'value'},
            ],
            offerHeaders: [
                {text: 'Firma', value: 'company'},
                {text: 'Wartość', value: 'value'},
                {text: 'Data złożenia', value: 'createdAt'},
                {text: 'Dodatkow informacje', value: 'notes'},
                {text: 'Status', value: 'status'},
                {text: 'Realizacja', value: 'fulfillment'},
            ],
            wholesaleInquiry: {},
            details: [],
            loadingDetails: false,
            apiBaseUrl: process.env.VUE_APP_API_URL,
            appBaseUrl: process.env.VUE_APP_APP_URL,
        }
    },
    methods: {
      getOfferStatusText,
        getFulfillmentText(status) {
            const map = {
                pending: 'Oczekuje',
                realized: 'Zrealizowany',
                unrealized: 'Niezrealizowany',
            };
            return map[status] || 'Oczekuje';
        },
        async loadDetails() {
            this.loadingDetails = true;

            const response = await api.get(`/api/wholesale-inquiries/${this.wholesaleInquiryId}`);
            this.wholesaleInquiry = response.data
            this.details.length = 0; // Trick to empty the array without changing the reference!
            this.loadingDetails = false;
            this.details = [
                {
                    name: 'Nazwa firmy',
                    value: this.wholesaleInquiry.companyName,
                },
                {
                    name: 'Imię i nazwisko',
                    value: this.wholesaleInquiry.name,
                },
                {
                    name: 'E-mail',
                    value: this.wholesaleInquiry.email,
                },
                {
                    name: 'Numer telefonu',
                    value: this.wholesaleInquiry.phone,
                },
                {
                    name: 'Kategoria',
                    value: this.wholesaleInquiry.category,
                },
                {
                    name: 'Miasto',
                    value: this.wholesaleInquiry.city,
                },
                {
                    name: 'Ilość pojazdów',
                    value: this.wholesaleInquiry.numberOfCars,
                },
                {
                    name: 'Marka i model samochodu',
                    value: this.wholesaleInquiry.model,
                },
                {
                    name: 'Pilne',
                    value: this.wholesaleInquiry.urgent ? 'Tak' : 'Nie',
                },
                {
                    name: 'Dodatkowe informacje',
                    value: this.wholesaleInquiry.additionalInformation,
                },
                {
                    name: 'Status',
                    value: getStatusText(this.wholesaleInquiry.status),
                },
            ];

        },
    },
    computed: {
    },

    async created() {
        try {
            this.wholesaleInquiryId = this.id; // Store new user id in the local variable.
            await this.loadDetails();
        } catch (e) {
            void (0);
        }
    },
    async beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.wholesaleInquiryId = to.params.id; // Store new user id in the local variable.

        await this.loadDetails();
    },
}
</script>

<style scoped>
.v-data-table
/deep/
tbody
/deep/
tr:hover:not(.v-data-table__expanded__content) {
    background: #ffffff !important;
}
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>